import { createFileRoute, useParams } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { BlogEditor } from "@/components/admin/blog/BlogEditor";

export const Route = createFileRoute("/_authenticated/admin/blog/$id")({
  head: () => ({
    meta: [
      { title: "Админ — Редакция на пост | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: EditorPage,
});

function EditorPage() {
  const { id } = useParams({ from: "/_authenticated/admin/blog/$id" });
  return (
    <AdminLayout>
      <BlogEditor id={id} />
    </AdminLayout>
  );
}